import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import fetch from 'cross-fetch';
import { isTest } from 'helpers/helper_functions';
import { getBearerGrantTypeAuthHeaders } from 'helpers/auth_helpers';

const getGraphQLClientOptions = ({ url }) => {
  const defaultOptions = {
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'none',
    },
  };
  const cache = new InMemoryCache({});
  const connectToDevTools = API_HOST === 'http://localhost:3050';
  const httpLinkOptions = {
    uri: url,
  };

  if (isTest()) {
    httpLinkOptions.fetch = fetch;
  }

  const httpLink = createHttpLink(httpLinkOptions);

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: getBearerGrantTypeAuthHeaders(),
      },
    };
  });

  const options = {
    link: authLink.concat(httpLink),
    cache,
    defaultOptions,
    connectToDevTools,
  };

  return options;
};

const getGraphQLClient = ({ url }) => {
  const options = getGraphQLClientOptions({ url });
  return new ApolloClient(options);
};

export { getGraphQLClient };
